import { useEffect, useState } from 'react';
import { inject, observer } from 'mobx-react';

import type RootStore from '../../../../../../stores/RootStore';
import { type TextInputAnswer } from '../../../../../../types/userAnswer';
import TextLimitCounter from '../TextLimitCounter/TextLimitCounter';
import styles from './TextInput.module.scss';

interface TextInputProps {
  limit?: number;
  rootStore?: RootStore;
  questionnaireQuestionsId: number;
}

const TextInput: React.FC<TextInputProps> = observer(
  ({ rootStore, limit = 200, questionnaireQuestionsId }) => {
    const limitTolerance = 10;
    const userAnswersStore = rootStore?.userAnswersStore;
    const savedInput = userAnswersStore?.userPageAnswers[
      questionnaireQuestionsId
    ] as TextInputAnswer;
    
    const [text, setText] = useState(savedInput?.text ?? '');
    useEffect(() => { setText(savedInput?.text ?? ''); }, [savedInput]);
    
    const handleTextChange = (
      event: React.ChangeEvent<HTMLInputElement>,
    ): void => {
      const inputText = event.target.value;
      if (inputText.length <= limit + limitTolerance) {
        userAnswersStore?.setAnswerForQuestion(questionnaireQuestionsId, {
          text: inputText,
          type: 'text_input',
        });
        setText(inputText);
      }
    };

    return (
      <div className={styles.container}>
        <input
          type="text"
          className={styles.altInputElement}
          onChange={handleTextChange}
          value={text}
        />
        <TextLimitCounter count={text.length} limit={limit} />
      </div>
    );
  },
);

export default inject('rootStore')(TextInput);
